import { ArticleJsonLd } from 'next-seo';

import { getPathWithDomain } from '@/utils/router.utils';

interface Props {
  title: string;
  images: string[];
  createdAt: string;
  updatedAt: string;
  path: string;
}

export const ArticleStructuredData = (props: Props) => {
  const { title, images, createdAt, updatedAt, path } = props;
  return (
    <ArticleJsonLd
      type="NewsArticle"
      title={title}
      images={images}
      description=""
      url={getPathWithDomain(path) || ''}
      datePublished={createdAt}
      dateModified={updatedAt}
      authorName={[
        {
          name: 'noweopony.pl Sp. Z o.o.',
          url: 'https://noweopony.pl/',
        },
      ]}
    />
  );
};
